import { render } from "./Nokia.vue?vue&type=template&id=00872f12&scoped=true"
import script from "./Nokia.vue?vue&type=script&lang=js"
export * from "./Nokia.vue?vue&type=script&lang=js"

import "./Nokia.vue?vue&type=style&index=0&id=00872f12&lang=scss&scoped=true"

import exportComponent from "E:\\Old Files\\Projecten Web\\Q-Mobile\\frame\\q-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00872f12"]])

export default __exports__